module.exports = __webpack_public_path__ + "img/@logo_hyundaicard@3x.2a985028.png";